import createClient from 'openapi-fetch';
import type { paths } from '../../types/yakubato-lp-api';
import { createApiRepository } from '../api';
import { config } from '../constants/app';

export type { ApiClient } from '../api';

export function createApi() {
  const client = createClient<paths>({ baseUrl: config.apiUrl });
  return createApiRepository(client);
}
